import styled from 'styled-components';
import {
  fontFamily,
  FontFamilyProps,
  fontSize,
  FontSizeProps,
  fontWeight,
  fontStyle,
  FontStyleProps,
  letterSpacing,
  LetterSpacingProps,
  lineHeight,
  LineHeightProps,
  textAlign,
  TextAlignProps,
  textStyle
} from 'styled-system';
import { basicTheme } from 'src/theme';
import { whiteSpace } from 'src/helpers';
import { baseBoxStyles, BaseBoxProps, boxStyles, BoxProps } from './Box';

const baseTextStyles: NonEmptyArray<any> = [
  fontFamily,
  fontSize,
  fontWeight,
  fontStyle,
  letterSpacing,
  lineHeight,
  textAlign,
  textStyle,
  whiteSpace
];

export type TextProps = BaseBoxProps &
  FontFamilyProps &
  FontSizeProps &
  FontStyleProps &
  LetterSpacingProps &
  LineHeightProps &
  TextAlignProps & {
    textStyle?: keyof typeof basicTheme.textStyles;
    fontWeight?: keyof typeof basicTheme.fontWeights;
    whiteSpace?: string;
  };
export const textStyles = [...baseBoxStyles, ...baseTextStyles];
export const Text = styled.div<TextProps>`
  ${textStyles}
`;
Text.defaultProps = {
  m: 0,
  p: 0
};

export type TextBoxProps = BoxProps &
  FontFamilyProps &
  LetterSpacingProps &
  LineHeightProps &
  TextAlignProps & {
    fontWeight?: keyof typeof basicTheme.fontWeights;
    textStyle?: keyof typeof basicTheme.textStyles;
  };
export const textBoxStyles = [...boxStyles, ...baseTextStyles];
export const TextBox = styled.div<TextBoxProps>`
  ${textBoxStyles};
`;

export const BaseHeading = styled(TextBox)``;
BaseHeading.defaultProps = {
  m: 0,
  fontFamily: 'robotoSlab',
  textAlign: 'center'
};

export const Heading1 = styled(BaseHeading)``;
Heading1.defaultProps = {
  as: 'h1',
  fontSize: 7,
  m: 0
};
export const Heading2 = styled(BaseHeading)``;
Heading2.defaultProps = {
  as: 'h2',
  mb: { xs: 40, md: 60 },
  fontSize: { xs: 6, md: 7 },
  lineHeight: 1.3
};

export const Heading3 = styled(BaseHeading)``;
Heading3.defaultProps = {
  as: 'h3',
  mb: { xs: 25, md: 30 },
  fontSize: { xs: 4, md: 5 },
  fontWeight: 'normal',
  lineHeight: 1.4,
  textAlign: 'left'
};

export const Heading4 = styled(BaseHeading)``;
Heading4.defaultProps = {
  as: 'h4',
  mb: 20,
  fontSize: 4,
  lineHeight: 1.3,
  textAlign: 'left'
};

export const Heading5 = styled(BaseHeading)``;
Heading5.defaultProps = {
  as: 'h5',
  mb: { xs: 20, md: 40 },
  fontSize: 3,
  textAlign: 'left'
};
